import {
  browserProfilingIntegration,
  browserTracingIntegration,
  captureConsoleIntegration,
  consoleLoggingIntegration,
  extraErrorDataIntegration,
  httpClientIntegration,
  init,
} from "@sentry/react"
import { getEnv } from "@/utils"

export default () => {
  init({
    dsn: getEnv("SENTRY_DSN"),
    environment: getEnv("ENVIRONMENT"),
    release: getEnv("RELEASE"),
    enableLogs: true,
    attachStacktrace: true,
    normalizeDepth: 10,
    integrations: [
      consoleLoggingIntegration({
        levels: ["info", "warn", "error", "log", "assert"],
      }),
      captureConsoleIntegration({ levels: ["error", "assert"] }),
      extraErrorDataIntegration(),
      httpClientIntegration(),
      browserTracingIntegration(),
      browserProfilingIntegration(),
      // TODO: fix
      //replayIntegration(),
    ],
    ignoreErrors: [],
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/promptjuggler/],
    profileSessionSampleRate: 0.1,
    profileLifecycle: "trace",
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
  })
}
